import { usePaperTriangleIconPositioning } from '@/features/notifications/components/NotificationCenter/hooks/usePaperTriangleIconPositioning'
import NotificationList from '@/features/notifications/components/NotificationCenter/parts/Paper/parts/NotificationList'
import TriangleIcon from '@/features/notifications/components/NotificationCenter/parts/Paper/parts/TriangleIcon'
import { ReadNotifications } from '@/features/notifications/components/NotificationCenter/types'
import { Notification } from '@/features/notifications/notification-service-extension-shared/types/app'
import { FC, RefObject, useEffect, useRef, useState } from 'react'
import { View } from 'react-native'

interface PaperProps {
    notifications: Notification[]
    readNotifications: ReadNotifications
    close: () => void
    anchorRef: RefObject<View | null>
}

const Paper: FC<PaperProps> = ({ notifications, readNotifications, close, anchorRef }) => {
    // immediate render of all notifications slows down TriangleIcon appearance
    // so pass notifications to FlashList on subsequent render after 'position' is set
    const [canRenderListItems, setCanRenderListItems] = useState(false)

    const listRef = useRef<View>(null)

    const [position, calculatePosition] = usePaperTriangleIconPositioning(anchorRef, listRef)

    useEffect(() => {
        if (position) setCanRenderListItems(true)
    }, [position])

    return (
        <>
            {position && <TriangleIcon style={position} />}
            <NotificationList
                notifications={canRenderListItems ? notifications : []}
                readNotifications={readNotifications}
                close={close}
                onLayout={calculatePosition}
                ref={listRef}
            />
        </>
    )
}

export default Paper
